export const GET_AI_WORKBOOK = "GET_AI_WORKBOOK";
export const GET_AI_WORKBOOK_SUCCESS = "GET_AI_WORKBOOK_SUCCESS";
export const GET_AI_WORKBOOK_ERROR = "GET_AI_WORKBOOK_ERROR";

export const DELETE_AI_WORKBOOK = "DELETE_AI_WORKBOOK";
export const DELETE_AI_WORKBOOK_SUCCESS = "DELETE_AI_WORKBOOK_SUCCESS";
export const DELETE_AI_WORKBOOK_ERROR = "DELETE_AI_WORKBOOK_ERROR";
